import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'

const COLORS = {
  SMG: '#FFFF00', // Accent Yellow
  DCM: '#000000', // Primary Black
  DRM: '#858585'  // Medium Gray
}

export default function ClientDistribution({ clients }) {
  const getCompanyData = () => {
    const companyCounts = clients.reduce((acc, client) => {
      acc[client.company] = (acc[client.company] || 0) + 1
      return acc
    }, {})

    return Object.entries(companyCounts).map(([company, count]) => ({
      name: company,
      value: count,
      color: COLORS[company] || '#cccccc'
    }))
  }

  const data = getCompanyData()

  const RADIAN = Math.PI / 180
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    if (!data[index]) return null

    const color = data[index].color
    const name = data[index].name

    const getLuminance = (hex) => {
      if (!hex) return 0
      hex = hex.replace('#', '')
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('')
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)
      return (r * 299 + g * 587 + b * 114) / 1000
    }
  
    const textColor = getLuminance(color) > 128 ? '#000000' : '#FFFFFF'
    
    if (percent === 0) return null

    return (
      <text x={x} y={y} fill={textColor} textAnchor="middle" dominantBaseline="central" fontSize="12px">
        <tspan x={x} dy="-0.6em" fontWeight="bold">{name}</tspan>
        <tspan x={x} dy="1.2em">{`${(percent * 100).toFixed(0)}%`}</tspan>
      </text>
    )
  }

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '20px 24px',
        borderBottom: '1px solid #e5e7eb'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#111827',
          margin: 0
        }}>
          Client Distribution by Company
        </h3>
      </div>

      {/* Content */}
      <div style={{ padding: '24px' }}>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{ 
                backgroundColor: 'rgba(31, 41, 55, 0.9)', 
                backdropFilter: 'blur(4px)', 
                border: '1px solid #4b5563', 
                borderRadius: '8px',
                color: '#f3f4f6'
              }}
              labelStyle={{ fontWeight: 'bold' }}
            />
            <Legend wrapperStyle={{ color: '#111827' }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}